import {
  DocumentFormUploadRequest,
  DocumentFormUploadResponse,
  DocumentListResponse,
} from '@Types/api/form';
import { getApiUrl } from '@Utils/getApiUrl';
import { ApiBaseName, ApiReducerPath } from '@Enum/index';
import { createApi } from '@reduxjs/toolkit/query/react';
import { extractAuthToken } from '@Utils/api/extractAuthToken';
import { customBaseQuery } from '@Utils/api/customBaseQuery';

const baseUrl = getApiUrl();

export const dmsApi = createApi({
  tagTypes: ['dms'],
  reducerPath: ApiReducerPath.API_DMS,
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    formUpload: builder.mutation<
      DocumentFormUploadResponse,
      DocumentFormUploadRequest
    >({
      query: ({ document, body }) => ({
        url: `${ApiBaseName.DMS}/document/upload`,
        method: 'post',
        body,
        formData: true,
        params: { document },
      }),
    }),
    formList: builder.mutation<DocumentListResponse[], string>({
      query: (fileFolder) => ({
        url: `${ApiBaseName.DMS}/document/list`,
        method: 'get',
        params: { path: fileFolder },
      }),
    }),
    downloadDocument: builder.query<string, string>({
      queryFn: async (documentId, { getState }) => {
        const token = extractAuthToken(getState);
        const response = await fetch(
          `${baseUrl}/${ApiBaseName.DMS}/document/download?document_id=${documentId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const imageBlob = await response.blob();
        const imageObjectURL = URL.createObjectURL(imageBlob);

        return {
          data: imageObjectURL,
        };
      },
    }),
    deleteDocumentById: builder.mutation<null, string>({
      query: (documentId) => ({
        url: `${ApiBaseName.DMS}/document/${documentId}`,
        method: 'delete',
      }),
    }),
  }),
});

export const {
  useFormUploadMutation,
  useFormListMutation,
  useDeleteDocumentByIdMutation,
  useDownloadDocumentQuery,
} = dmsApi;
